/**
 * @final 
 * @export
 */
export default class Ticker {
  /** 
   * Create new Timer. committed to a single callback function.
   * @param {function()} onTick 
   */
  constructor(onTick) {

    /** @private {!function()} */
    this.onTick_ = onTick

    /** @private {?function()} */
    this.cancleTick_ = null

    return this
  }
  
  /** regular intervals */
  tick(timeInSeconds) {
    let alive = true
    let timeoutId = null
    this.cancleTick_ = () => {
      window.clearTimeout(timeoutId)
      alive = false
    }
    timeoutId = window.setTimeout(() => {
      if (alive) this.onTick_()
    }, timeInSeconds * 1000)

    return this
  }

  /** clearTimeout */
  stop() {
    if (this.cancleTick_) {
      this.cancleTick_()
      this.cancleTick_ = null
    }
  }
}